var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_916_1366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.05263 0H26.9474C28.2874 0 29.5726 0.532329 30.5201 1.47988C31.4677 2.42743 32 3.71259 32 5.05263V20.2105C32 21.5506 31.4677 22.8357 30.5201 23.7833C29.5726 24.7308 28.2874 25.2632 26.9474 25.2632H5.05263C3.71259 25.2632 2.42743 24.7308 1.47988 23.7833C0.532329 22.8357 0 21.5506 0 20.2105V5.05263C0 3.71259 0.532329 2.42743 1.47988 1.47988C2.42743 0.532329 3.71259 0 5.05263 0ZM5.05263 1.68421C4.21053 1.68421 3.46947 1.97053 2.89684 2.47579L16 10.9474L29.1032 2.47579C28.5305 1.97053 27.7895 1.68421 26.9474 1.68421H5.05263ZM16 12.9853L1.90316 3.84C1.76842 4.21053 1.68421 4.63158 1.68421 5.05263V20.2105C1.68421 21.1039 2.0391 21.9607 2.6708 22.5924C3.3025 23.2241 4.15927 23.5789 5.05263 23.5789H26.9474C27.8407 23.5789 28.6975 23.2241 29.3292 22.5924C29.9609 21.9607 30.3158 21.1039 30.3158 20.2105V5.05263C30.3158 4.63158 30.2316 4.21053 30.0968 3.84L16 12.9853Z",
    fill: "url(#paint0_linear_916_1366)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_916_1366",
    x1: 0,
    y1: 12.6316,
    x2: 32,
    y2: 12.6316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#503D75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_916_1366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 25.2632,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.da21aead54bd191b1048dc8df9159a41.svg";
export { ForwardRef as ReactComponent };